import { fixedAssets } from 'src/containers/PreCache'

import { onDemandVideosType } from './videos'
import routes from 'src/routes'

export interface onDemandCategoryType {
  id: number
  title: string
  categoryName?: string
  thumbnail: string
  profile?: string
  destination?: string
  embedUrl?: string
  videos?: Array<onDemandVideosType>
}

type PdfViewType = {
  id: string | number
  title: string
  thumbnail: string
  filePath: string
}
type VideoType = {
  id: string | number
  title: string
  thumbnail: string
  iframeUrl: string
}

type Day1Slides = PdfViewType
type Day2Slides = PdfViewType
type UpcomingEvents = PdfViewType

const onDemandCategories: Array<onDemandCategoryType> = [
  {
    id: 1,
    thumbnail: fixedAssets.videoIcon,
    title: 'Videos',
    destination: routes.galleryDay1Videos,
  },
  // {
  //   id: 2,
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Day 2 Videos',
  //   destination: routes.galleryDay2Videos,
  // },
  // {
  //   id: 3,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'PDF Brochure',
  //   destination: routes.onDemandDay1,
  // },
  // {
  //   id: 4,
  //   thumbnail: fixedAssets.posterIcon,
  //   title: 'Image Poster',
  //   destination: routes.onDemandDay2,
  // },
  // {
  //   id: 5,
  //   thumbnail: fixedAssets.folderIcon,
  //   title: "Upcoming Events",
  //   destination: routes.onDemandUpcomingEvents,
  // },
]

const day1Slides: Day1Slides[] = [
  // {
  //   id: 1,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 2 - Dr. Veerinderjeet Singh',
  //   filePath: '/gallery/day1/Topic 2 - Dr. Veerinderjeet Singh.pdf',
  // },
  // {
  //   id: 2,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 3 - Mr. Richard Needs',
  //   filePath: '/gallery/day1/Topic 3 - Mr. Richard Needs.pdf',
  // },
  // {
  //   id: 3,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 4',
  //   filePath: '/gallery/day1/Topic 4.pdf',
  // },
]

const day2Slides: Day2Slides[] = [
  // {
  //   id: 4,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 5',
  //   filePath: '/gallery/day1/Topic 5.pdf',
  // },
  // {
  //   id: 5,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 7 - Mr. Jason Tan',
  //   filePath: '/gallery/day1/Topic 7 - Mr. Jason Tan.pdf',
  // },
  // {
  //   id: 6,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 7 - Mr. Shafudin',
  //   filePath: '/gallery/day1/Topic 7 - Mr. Shafudin.pdf',
  // },
  // {
  //   id: 7,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 7 - Ms. Margaret Lee',
  //   filePath: '/gallery/day1/Topic 7 - Ms. Margaret Lee.pdf',
  // },
  // {
  //   id: 8,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 8 - Ms Zaleha Adam',
  //   filePath: '/gallery/day1/Topic 8 - Ms Zaleha Adam.pdf',
  // },
]

const upcomingEvents: UpcomingEvents[] = [
  // {
  //   id: 1,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Latest Brochure',
  //   filePath: '/gallery/upcoming-events/Latest Brochure.pdf',
  // },
  // {
  //   id: 2,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Preparing a Defense Ready Transfer Pricing TP Documentation which Complies with TP Rules 2023',
  //   filePath: '/gallery/upcoming-events/Preparing a Defense Ready Transfer Pricing TP Documentation which Complies with TP Rules 2023.pdf',
  // },
  // {
  //   id: 3,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Staying Ahead of the Latest Tax Developments and Issues in Malaysia',
  //   filePath: '/gallery/upcoming-events/Staying Ahead of the Latest Tax Developments and Issues in Malaysia.pdf',
  // },
  // {
  //   id: 4,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Towards Readiness for Employers and Payroll Audit',
  //   filePath: '/gallery/upcoming-events/Towards Readiness for Employers and Payroll Audit.pdf',
  // },
]
const day1Videos: VideoType[] = [
  {
    id: 'Principal 2026 Q2 Agency Rolldown Event Playback',
    thumbnail: fixedAssets.videoIcon,
    title: 'Principal 2026 Q2 Agency Rolldown Event Playback',
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/60c29df0-3805-48bf-9a51-4ac3c3d0a6d1',
  },
  // {
  //   id: 'Topic 1 - Beyond Compliance: Building Trust through Engagement',
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Topic 1 - Beyond Compliance: Building Trust through Engagement',
  //   iframeUrl: 'https://drive.google.com/file/d/1-63jatSAyJ6BEAqgef8aiEaNAbOjLyKD/view',
  // },
  // {
  //   id: "Topic 2 - 2025 and Beyond: Economic Trends Influencing Malaysia's MADANI Pathway",
  //   thumbnail: fixedAssets.videoIcon,
  //   title: "Topic 2 - 2025 and Beyond: Economic Trends Influencing Malaysia's MADANI Pathway",
  //   iframeUrl: 'https://drive.google.com/file/d/1pgRX4m68YgOLzrQOQduc2SOp2Vl2k55u/view',
  // },
  // {
  //   id: "Topic 3 - e-Invoice: Experiences from other Countries and What's in Store",
  //   thumbnail: fixedAssets.videoIcon,
  //   title: "Topic 3 - e-Invoice: Experiences from other Countries and What's in Store",
  //   iframeUrl: 'https://drive.google.com/file/d/1rGLX9isAx_JvCBh9lxPQM4zQE0hRMaDP/view',
  // },
  // {
  //   id: "Topic 4 - Understanding Malaysia's Transfer Pricing Updates: Implications and Strategies for Business",
  //   thumbnail: fixedAssets.videoIcon,
  //   title: "Topic 4 - Understanding Malaysia's Transfer Pricing Updates: Implications and Strategies for Business",
  //   iframeUrl: 'https://drive.google.com/file/d/1FmLqNQewQn69nzT-9JZz4TQ3u8b1ekhn/view',
  // },
]

const day2Videos: VideoType[] = [
  // {
  //   id: 'Overview of Day 1',
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Overview of Day 1',
  //   iframeUrl: 'https://drive.google.com/file/d/17eYGfbZ7IUsop99239DNI71ZYZB-lhHK/view',
  // },
  // {
  //   id: 'Topic 5 - Roundtable Discussion on Current Challenges Faced by Taxpayers',
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Topic 5 - Roundtable Discussion on Current Challenges Faced by Taxpayers',
  //   iframeUrl: 'https://drive.google.com/file/d/1os56Ew-QOZqfveJJ2VeUeI6qGK15CoxT/view',
  // },
  // {
  //   id: 'Topic 6 - From Enforcement to Engagement: Tax Compliance Strategies in the Regional Context',
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Topic 6 - From Enforcement to Engagement: Tax Compliance Strategies in the Regional Context',
  //   iframeUrl: 'https://drive.google.com/file/d/1rdij7CE_YOG52kZpiX5_d9w2oHwvksXw/view',
  // },
  // {
  //   id: 'Topic 7 - Adapting to Self-Assessment for RPGT and Stamp Duty',
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Topic 7 - Adapting to Self-Assessment for RPGT and Stamp Duty',
  //   iframeUrl: 'https://drive.google.com/file/d/1QdsY4nmCM0EnsKfk-E3E3gGPIsnRfTYb/view',
  // },
  // {
  //   id: 'Topic 8 - Updates of Tax Cases',
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Topic 8 - Updates of Tax Cases',
  //   iframeUrl: 'https://drive.google.com/file/d/1RTtFaZ6pbkr3-jpVvQd6na9Ek8dRSWFi/view',
  // },
]

export { onDemandCategories, day1Slides, day2Slides, upcomingEvents, day1Videos, day2Videos }
